import { StrokeLog } from './strokes';

/** Plain serializable player transform — what a network layer would sync. */
export interface PlayerTransform {
  pos: [number, number, number];
  yaw: number;
  pitch: number;
}

/**
 * The complete logical state of a world session, kept apart from rendering.
 * Everything here is serializable (or derivable from serializable data), so
 * multiplayer sync/persistence later is a transport problem, not a rewrite.
 */
export class GameState {
  readonly strokes = new StrokeLog();
  locationId = '';
  /** 0..1 snowfall intensity (0 = clear skies, 1 = blizzard). */
  snowfallIntensity = 0.3;
  /** Seed shared by snowfall + terrain detail so clients could agree on it. */
  worldSeed = 1;
  /** Epoch (performance.now ms) of the current world session; stroke.t is relative to it. */
  epoch = 0;
  player: PlayerTransform = { pos: [0, 0, 0], yaw: 0, pitch: 0 };

  resetWorld(): void {
    this.strokes.clear();
    this.epoch = performance.now();
  }
}
